/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { get } from 'lodash';
import { getCurrentQuestionSet } from '../../../redux/selector/questions';

const NeedHelpWrapper = styled.div`
  --text-color: white;
  --font-medium: Avenir-Medium;
  --font-heavy: Avenir-Heavy;
  --font-weight: 900;
  --line-height: 18px;
`;

const NeedHelpDialogWrapper = styled.div`
  display: ${({ showModal }) => (showModal ? 'none' : 'flex')};
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #be1e2c;
  position: fixed;
  bottom: 20px;
  right: 2%;
  cursor: pointer;
  transition: 0.2s;
  z-index: ${({ showModal }) => (showModal ? '-3000' : '3000')};

  &:active {
    transform: scale(0.9);
  }

  &:focus {
    outline: 3px solid #c65001;
    outline-offset: 3px;
  }

  @media only screen and (max-width: 768px) {
    width: 80px;
    height: 80px;
    bottom: 4%;
    right: 3%;
  }
`;

const NeedHelpDialogContainer = styled.div`
  width: 100%;
  position: relative;
`;

const NeedHelpDialogImg = styled.img`
  width: 100%;
  position: absolute;
  top: -25px;
  @media only screen and (max-width: 768px) {
    top: -20px;
  }
`;

const NeedHelpText = styled.div`
  font-family: var(--font-medium);
  font-size: 19px;
  font-weight: var(--font-weight);
  line-height: var(--line-height);
  color: var(--text-color);
  width: 50%;
  position: absolute;
  bottom: 15%;
  left: 32%;

  @media only screen and (max-width: 768px) {
    font-size: 13px;
    line-height: 15px;
    left: 34%;
  }
`;

const NeedHelpModal = styled.div`
  opacity: ${({ showModal }) => (showModal ? '1' : '0')};
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: ${({ showModal }) => (showModal ? '3000' : '-3000')};
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.4);
  width: 376px;
  transition: all 0.2s ease-in-out;
  background: #ffffff;
  content-width: 85%;
  header-width: 75%;
  @media only screen and (max-width: 768px) {
    width: 294px;
    --font-size: 13px;
  }
`;

const NeedHelpModalHead = styled.div`
  background: #18355e;
  min-height: ${({ title }) =>
    title.length <= 30 ? `${2.5 * title.length}px` : `${1.6 * title.length}px`};
  color: var(--text-color);
  font-family: var(--font-heavy);
  font-display: swap;
  line-height: var(--line-height);
  font-size: 20px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    width: 75%;
    max-width: 75%;
    margin-left: 20.5%;
    line-height: 23px;
    color: var(--text-color);
  }
  > span > img {
    width: 25px;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
  }

  @media only screen and (max-width: 768px) {
    font-size: 16px;
    > span > img {
      margin-left: 0;
      width: 21px;
    }
  }
`;

const NeedHelpModalBody = styled.div`
  display: grid;
  margin-bottom: 20px;
  grid-template-rows: repeat(auto-fit, minmax(35px, 1fr));
  align-items: center;
  justify-items: center;

  > * + * {
    margin-top: 25px;
  }

  > * {
    width: 85%;
  }

  > div {
    font-family: var(--font-heavy);
    font-display: swap;
    font-size: 17px;
    font-weight: normal;
  }

  #needHelpInstructions {
    padding-bottom: 40px;
  }

  @media only screen and (width: 1024px) {
    > div {
      font-size: 14px;
    }
  }
`;

const NeedHelpButton = styled.button`
  color: var(--text-color);
  background-color: #be1e2c;
  border: none;
  width: 200px;
  height: 56px;
  padding: 0px 44px;
  margin-right: 100px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: var(--font-heavy);
  font-display: swap;
  cursor: pointer;
  font-size: 16px;
  transform: skew(-20deg);

  @media only screen and (max-width: 768px) {
    margin-right: 30px;
  }
`;

const NeedHelpPopupDialog = ({ global, needHelpPopupDialog, isDtc }) => {
  if (!isDtc) {
    return null;
  }

  const [showModal, setShowModal] = useState(false);

  const handleKeyDown = (e, isModalClose, isPopupDiloagKeyEvent) => {
    const isEnterPressed = e.key === 'Enter' || e.keyCode === 3;
    const isSpacePressed = e.key === 'Space' || e.keyCode === 32;

    if (isPopupDiloagKeyEvent && (isEnterPressed || isSpacePressed)) {
      setShowModal(!showModal);
      e.preventDefault();
    }

    if (isModalClose && isEnterPressed) setShowModal(!showModal);
  };

  const tabIndex = { tabIndex: showModal ? 0 : -1 };

  return (
    <NeedHelpWrapper>
      <NeedHelpDialogWrapper
        role='button'
        showModal={ showModal }
        id='needHelpPopupDialog'
        onClick={ () => setShowModal(!showModal) }
        onKeyDown={ (e) => handleKeyDown(e, undefined, true) }
        tabIndex={ 0 }
        aria-label='Need Help?'
      >
        <NeedHelpDialogContainer>
          <NeedHelpDialogImg src={ global.dialogBoxImg } alt='' />
          <NeedHelpText>Need Help?</NeedHelpText>
        </NeedHelpDialogContainer>
      </NeedHelpDialogWrapper>
      <NeedHelpModal
        id='needHelpPopupModal'
        showModal={ showModal }
        onKeyDown={ (e) => handleKeyDown(e) }
      >
        <NeedHelpModalHead title={ needHelpPopupDialog.title }>
          <div>{needHelpPopupDialog.title}</div>
          <span
            id='crossMarkImg'
            aria-label='clickable Close Need Help Widget button'
            onClick={ () => setShowModal(!showModal) }
            onKeyDown={ (e) => handleKeyDown(e, true) }
            { ...tabIndex }
          >
            <img width='100%' height='100%' alt='' src={ global.crossMarkImg } />
          </span>
        </NeedHelpModalHead>
        <NeedHelpModalBody>
          <div>{needHelpPopupDialog.content}</div>
          <div>{needHelpPopupDialog.phoneNumber}</div>
          <NeedHelpButton
            aria-label='Schedule a Consultation.'
            onClick={ () => {
              window.open(needHelpPopupDialog.sheduleConsultationUrl, '_blank');
            } }
            { ...tabIndex }
          >
            {needHelpPopupDialog.consultationButton}
          </NeedHelpButton>
          <div id='needHelpInstructions'>{needHelpPopupDialog.instructions}</div>
        </NeedHelpModalBody>
      </NeedHelpModal>
    </NeedHelpWrapper>
  );
};

const mapStateToProps = (state) => {
  const { otherParams } = getCurrentQuestionSet(state);
  const isDtc = get(otherParams, 'is_dtc', true);
  return { isDtc };
};

export default withTheme(connect(mapStateToProps)(NeedHelpPopupDialog));
